@let userProfile = userProfile$ | async;
@let externalId = externalId$ | async;

<div class="impersonation-banner-container">
  <div class="impersonation-info-container">
      <c-icon [icon]="faUserSecret" size="xl" />
      <p>{{ 'impersonation.banner.description' | transloco }} {{ userProfile?.firstName }} {{ userProfile?.lastName}} ({{ externalId }})</p>
  </div>
  <div class="language-selector">
    <c-button type="ghost" size="small" [fullWidth]="false" (action)="openLanguagePicker()">
      <div class="flex">
        @if (selectedLanguage()) {
          <c-language-item [language]="selectedLanguage()" variant="select" />
        }
        <img src="assets/img/down.svg" [alt]="'common.alt-image' | transloco" />
      </div>
    </c-button>
  </div>
</div>